import { IBaseAllergy } from '../../../interfaces';
import { BaseMedicalConditionToMedicalHistoryHandler } from '../../../mappings/medical-condition-to-medical-history';
import {
  D4WPatientMedicalConditionOptions,
  ID4WMedicalConditionOption,
  PatientMedicalConditionOptionsSourceEntity,
} from '../../source/entities/patient-medical-condition-options';

export class D4WMedicalConditionToMedicalHistoryMappingHandler extends BaseMedicalConditionToMedicalHistoryHandler<
  D4WPatientMedicalConditionOptions,
  PatientMedicalConditionOptionsSourceEntity
> {
  sourceEntity = new PatientMedicalConditionOptionsSourceEntity();
  translateFn = (record: ID4WMedicalConditionOption): IBaseAllergy => ({
    description: record.description,
    id: record.id,
  });
}
